export default __webpack_public_path__ + "static/media/menu-h_m_04.3d107e9b.jpg";